import type { ProductConfig } from '../../default/product/product.types';
import type { DeepPartial } from '../../default/types';

export const productConfig: DeepPartial<ProductConfig> = {
  activeABTests: {
    // TODO: INFORM-4233: remove after test is done
    usp: '2026_4_usp_components',
  },
  cliplister: {
    customerId: '80936',
  },
  recommendations: {
    dv: {
      slots: {
        '3': 'miraklProducts',
      },
    },
  },
  usps: ['INVOICE', 'INSTALLMENTS', '30_DAYS_RETURN'],
};
